import { ChangeDetectionStrategy, Component, Input, OnInit, ViewChild, inject } from '@angular/core';
import {
  MatLegacyDialogRef as MatDialogRef,
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
} from '@angular/material/legacy-dialog';
import { AppConstants } from '@core/constants';
import { EditTextDialogData } from '@shared/interfaces/edit-text-dialog.interface';
import { TextEditorComponent } from '@modules/administration/report-template/text-editor/text-editor.component';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-edit-text-dialog',
  templateUrl: './edit-text-dialog.component.html',
  styleUrls: ['./edit-text-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EditTextDialogComponent implements OnInit {
  @ViewChild(TextEditorComponent) textEditorComponent: TextEditorComponent;

  private readonly dialogRef = inject(MatDialogRef<EditTextDialogComponent>);
  private readonly fb = inject(FormBuilder);

  @Input() id: string = '';
  @Input() width: number = 250;

  PREVIEW_PDF: string = AppConstants.TEXT_EDITOR_VIEW_TYPE.PREVIEW_PDF;
  textFromEditor: string = '';
  canEditContent: boolean = true;
  canEditHeading: boolean = true;
  form: FormGroup;

  data: EditTextDialogData = inject(MAT_DIALOG_DATA);

  ngOnInit(): void {
    this.textFromEditor = this.data.content;
    this.canEditContent = this.data.canEditContent ?? true;
    this.canEditHeading = this.data.canEditHeading ?? true;
    this.form = this.fb.group({
      heading: [this.data.heading],
    });
  }

  onUpdate(): void {
    let content: string = '';
    try {
      content = this.textEditorComponent.getModel();
    } catch (TypeError) {
      content = '';
    }

    const heading = this.form.value.heading;
    this.dialogRef.close({ heading, content });
  }
}
